import Dialog from "@mui/material/Dialog";
import React, { useEffect, useState } from "react";

import CustomerDetails, { TicketGroups } from "./CustomerDetails";
import PhoneInput from "./PhoneInput";
import { validPhone } from "./useMegawinPurchase";

export default function CustomerModal({ open, onClose, purchase, sections }) {
  const [checkoutId, setCheckoutId] = useState("");
  useEffect(() => {
    setCheckoutId("");
  }, [purchase.phone]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="megawin-customer-title"
      maxWidth={false}
      PaperProps={{ className: "megawin-checkout" }}
    >
      <header className="megawin-checkout-header">
        <h2 id="megawin-customer-title">Тасалбар шалгах</h2>
        <button
          type="button"
          className="megawin-close"
          aria-label="Хаах"
          onClick={onClose}
        >
          ×
        </button>
      </header>
      <div className="megawin-checkout-body">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            purchase.loadCustomer();
          }}
        >
          <PhoneInput
            id="customer-phone"
            phone={purchase.phone}
            setPhone={purchase.setPhone}
          />
          <button
            type="submit"
            className="megawin-orange-button"
            disabled={purchase.busy || !validPhone(purchase.phone)}
          >
            {purchase.customerLoading
              ? "Ачаалж байна…"
              : "Худалдан авалтууд харах"}
          </button>
        </form>
        <CustomerDetails
          customer={purchase.customer}
          sections={sections}
          busy={purchase.busy}
          onCheckTickets={purchase.checkTickets}
        />
        <form
          className="mw-ticket-lookup"
          onSubmit={(event) => {
            event.preventDefault();
            purchase.checkTickets(checkoutId);
          }}
        >
          <label htmlFor="ticket-checkout-id">Захиалгын дугаар</label>
          <input
            id="ticket-checkout-id"
            className="megawin-phone"
            required
            value={checkoutId}
            onChange={(event) => setCheckoutId(event.target.value)}
          />
          <p className="megawin-checkout-note">
            Энэ хэсэг олгогдсон тасалбаруудыг харуулна. Хожлын үр дүн шалгахгүй.
          </p>
          <button
            type="submit"
            className="megawin-orange-button"
            disabled={
              purchase.busy || !validPhone(purchase.phone) || !checkoutId.trim()
            }
          >
            Тасалбар шалгах
          </button>
        </form>
        {purchase.tickets && (
          <section aria-label="Олгогдсон тасалбарууд">
            <h3>Олгогдсон тасалбарууд</h3>
            <p>{purchase.tickets.checkoutId}</p>
            {purchase.tickets.items.length ? (
              <TicketGroups
                tickets={purchase.tickets.items}
                sections={sections}
              />
            ) : (
              <p>Олгогдсон тасалбар байхгүй байна.</p>
            )}
          </section>
        )}
        {purchase.error && (
          <p role="alert" className="megawin-checkout-error">
            {purchase.error}
          </p>
        )}
      </div>
    </Dialog>
  );
}
